export default "__VITE_ASSET__DSEP0FDk__"